module.exports = ".example {\n    margin-right: 8px;\n  }\n  "